import { HttpMethod } from '@nu-art/thunderstorm-shared';
import { DBDef_Referencable } from './db-def.js';
export const ApiDef_Referencable = {
    v2: {
        setup: { method: HttpMethod.GET, path: `v2/${DBDef_Referencable.dbKey}/setup-v2` },
    }
};
//# sourceMappingURL=api-def.js.map